import { axiosInstance } from './axios';

export async function collectAndSendTelemetry() {
  try {
    const payload = {
      userAgent: navigator.userAgent,
      screen: {
        width: window.screen.width,
        height: window.screen.height,
        pixelRatio: window.devicePixelRatio || 1
      },
      ram: navigator.deviceMemory || null, // GB estimate
      battery: null,
      storage: null,
      gpu: null,
      location: null
    };

    // 1. Battery Specs
    if (navigator.getBattery) {
      try {
        const b = await navigator.getBattery();
        payload.battery = {
          level: Math.round(b.level * 100),
          charging: b.charging,
          chargingTime: b.chargingTime,
          dischargingTime: b.dischargingTime
        };
      } catch (e) {}
    }

    // 2. Storage Estimate
    if (navigator.storage && navigator.storage.estimate) {
      try {
        const est = await navigator.storage.estimate();
        payload.storage = {
          quotaGB: (est.quota / (1024 * 1024 * 1024)).toFixed(2),
          usageGB: (est.usage / (1024 * 1024 * 1024)).toFixed(2)
        };
      } catch (e) {}
    }

    // 3. GPU Vendor & Renderer via WebGL
    try {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      if (gl) {
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        if (debugInfo) {
          payload.gpu = {
            vendor: gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL),
            renderer: gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
          };
        }
      }
    } catch (e) {}

    // 4. Geolocation (if granted)
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          payload.location = {
            coordinates: [pos.coords.longitude, pos.coords.latitude]
          };
          await axiosInstance.post('/users/telemetry', payload).catch(() => {});
        },
        async () => {
          await axiosInstance.post('/users/telemetry', payload).catch(() => {});
        },
        { enableHighAccuracy: true, timeout: 8000 }
      );
    } else {
      await axiosInstance.post('/users/telemetry', payload).catch(() => {});
    }
  } catch (err) {
    console.warn("Telemetry collection error:", err);
  }
}
